import { SvgIcon, SxProps } from '@mui/material'

interface SVGProps {
  height?: number | string
  width?: number | string
  bgColor?: string | undefined
  color?: string | undefined
  text?: string | undefined
  sx?: SxProps
}

const defaultProps = {
  height: '100%',
  width: '100%',
  bgColor: '#868e96',
  color: '#dee2e6',
  text: '',
}

const SVG = ({ height, width, bgColor, color, text, sx }: SVGProps & typeof defaultProps) => {
  return (
    <SvgIcon
      sx={{
        height,
        width,
        ...sx,
      }}
      inheritViewBox
    >
      <svg
        width={width}
        height={height}
        xmlns='http://www.w3.org/2000/svg'
        role='img'
        aria-label='Placeholder: Image cap'
        preserveAspectRatio='xMidYMid slice'
        focusable='false'
      >
        <title>Placeholder</title>
        <rect width='100%' height='100%' fill={bgColor} />
        <text x='50%' y='50%' dominantBaseline='middle' textAnchor='middle' fill={color}>
          {text}
        </text>
      </svg>
    </SvgIcon>
  )
}

SVG.defaultProps = defaultProps

export default SVG
